import React, { useState, useEffect } from 'react'
import { Grid } from '@material-ui/core'
import MaterialTable from 'material-table'
import axios from 'axios'
import { get, has } from 'lodash'
import CustomizedSnackbars from '../../../components/MessageSnacks/CustomizedSnackbars'
import { useMasterState } from '../../../context/MasterContext'

const columns = [
    { title: 'Name', field: 'name' },
    { title: 'Job Title', field: 'job_title' },
    { title: 'Job Function', field: 'job_function'},
    { title: 'Email', field: 'email' },
];

export default function StaffList(props) {

    var [staffList, setStaffList] = useState([])
    var [staffListVersion, setStaffListVersion] = useState(0)
    var [userRoles, setUserRoles] = useState([])
    var [open, setOpen] = useState(false)
    var [errorMessage, setErrorMessage] = useState('')
	var { masterData } = useMasterState()

    useEffect(() => {
		function getUserRoles(){
			let lookup = {}
			masterData.roles.forEach((object, key) => {
				if (object.id !== 1) {
					lookup[object.id] = object.name
				}
			})
			let rolesColumn = {
				title: 'User Role',
				field: 'roles[0].id',
				lookup: lookup
			}
			setUserRoles(rolesColumn)
		}

        getUserRoles()
    }, [masterData.roles])

    useEffect(() => {
        getStaff()
    }, [staffListVersion])

    const getStaff = async () => {
        await axios.get('/api/users').then(res => {
            let staff_List = get(res.data.data, 'data', [])
            setStaffList(staff_List)
        }).catch(error => {
            console.log('Fetching users list error', error)
        })

    }



    const addStaff = async userData => {
        let params = {
            'user': {
                name: userData.name,
                job_title: userData.job_title,
                job_function: userData.job_function,
                email: userData.email,
            },
            'role': {
                role_id: userData.roles[0].id
            }
        }
        await axios.post('/api/users/', params).then(res => {
            if (res.data.status) {
                setStaffListVersion(staffListVersion + 1)
                setOpen(false)
            } else {
                setErrorMessage(res.data.message)
                setOpen(true)
            }
        }).catch(error => {
            console.log('Adding user error', error)
        })
    }

    const validateFields = (userData, updating) => {
        let isValid = true
        if(!updating){
            columns.forEach(column => {
                if (!(has(userData, column.field))) {
                    isValid = false
                }
                if (!(has(userData, 'roles'))) {
                    isValid = false
                }
            })
        }else{
            columns.forEach(column => {
                if(has(userData, column.field)){
                    if(userData[column.field] === null){
                        isValid = false
                    }
                }
            })
        }
        return isValid
    }

    const updateStaff = async (userData, id) => {
        let params = {
            'user': {
                name: userData.name,
                job_title: userData.job_title,
                job_function: userData.job_function,
                phone_cc: userData.phone_cc,
                phone_no: userData.phone_no,
                email: userData.email,
            },
            'role': {
                role_id: userData.roles[0].id
            }
        }
        await axios.put('/api/users/' + userData.id, params).then(res => {
            setStaffListVersion(staffListVersion + 1)
        }).catch(error => {
            console.log('Updating user error', error)
        })

    }

    const deleteStaff = async id => {
        await axios.delete('/api/users/' + id).then(res => {
            setStaffListVersion(staffListVersion + 1)
        }).catch(error => {
            console.log('Deleting user error', error)
        })
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Grid container spacing={1}>
            <CustomizedSnackbars
                open={open}
                handleClose={handleClose}
                variant={'error'}
                message={errorMessage}
            />
            <Grid item xs={12}>
                <MaterialTable
                    title='Staff List'
                    columns={columns.concat(userRoles)}
                    data={staffList}
                    options={{
                        headerStyle: {
                            backgroundColor: '#D8E4E4',
                            color: 'black',
                        },
                        addRowPosition: 'first',
                        pageSize: 10,
                    }}
                    editable={{
                        onRowAdd: newData =>
                            new Promise(async (resolve, reject) => {
                                let isDataValid = await validateFields(newData, false)
                                if (isDataValid) {
                                    await addStaff(newData)
                                    resolve()
                                } else {
                                    setOpen(true)
                                    setErrorMessage('Please fill all fields')
                                    reject()
                                }
                            }),
                        onRowUpdate: (newData, oldData) =>
                            new Promise(async (resolve, reject) => {
                                let isDataValid = await validateFields(newData, true)
                                if (isDataValid) {
                                    const data = staffList
                                    const index = data.findIndex(
                                        x => x.id === oldData.id,
                                    )
                                    await updateStaff(newData, data[index].id)
                                    resolve()
                                } else {
                                    setOpen(true)
                                    setErrorMessage('Please fill all fields')
                                    reject()
                                }
                            }),
                        onRowDelete: oldData =>
                            new Promise(async resolve => {
                                const data = staffList
                                const index = data.findIndex(
                                    x => x.id === oldData.id,
                                )
                                data.splice(index, 1)
                                await deleteStaff(oldData.id)

                                resolve()
                            }),
                    }}
                />
            </Grid>
        </Grid>
    )
}
